import { Customer } from './Customer'

export class CustomerRequestDTO {

    customer : Customer

    constructor(customer : Customer) {
        this.customer = customer
    }

}